import React, {useEffect} from 'react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import PropTypes from 'prop-types'

const BootstrapProvider = ({children}) => {
    useEffect(() => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = getAssetUrl('static/bootstrap.min.css')
        document.head.appendChild(link)

        return () => {
            document.head.removeChild(link)
        }
    }, [])

    return (
        <>
            <link
                rel="stylesheet"
                type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css"
            />
            {children}
        </>
    )
}

BootstrapProvider.propTypes = {
    children: PropTypes.node.isRequired
}
export default BootstrapProvider
